import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Build = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path d="M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4L2 4Z" fill="currentColor" />
    <path d="M2 6V8H22V6H2Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 10V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V10H2ZM18 12C18 13.2958 17.5892 14.4957 16.8907 15.4765L20 18.5858V12H18ZM13.4142 12H16C16 12.7418 15.7981 13.4365 15.4462 14.032L13.4142 12ZM8 12H10.5858L8.55382 14.032C8.20193 13.4365 8 12.7418 8 12ZM6 12C6 13.2958 6.41079 14.4957 7.10925 15.4765L4 18.5858V12H6ZM5.41421 20L8.52347 16.8907C9.50428 17.5892 10.7042 18 12 18C13.2958 18 14.4957 17.5892 15.4765 16.8907L18.5858 20H5.41421ZM12 16C12.7418 16 13.4365 15.7981 14.032 15.4462L12 13.4142L9.96803 15.4462C10.5635 15.7981 11.2582 16 12 16Z"
      fill="currentColor"
    />
  </Icon>
));

export default Build;
